import React, { useState } from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';

import Highlights from '../Highlights/Highlights';

import heroPhoto from './photos/hero.jpg';

import css from './Hero.module.css';

const services = [
  {
    id: 'newbornCare',
    messageId: 'LandingSpecialties.newbornCare',
    label: 'Newborn care',
    category: 'newborn-care-specialist',
  },
  {
    id: 'bellyBinding',
    messageId: 'LandingSpecialties.bellyBinding',
    label: 'Belly binding',
    category: 'bellibinding',
  },
  {
    id: 'lactation',
    messageId: 'LandingSpecialties.lactation',
    label: 'Lactation',
    category: 'lactation-consultant',
  },
  {
    id: 'lymphaticMassage',
    messageId: 'LandingSpecialties.lymphaticMassage',
    label: 'Lymphatic Massage',
    category: 'lymphatic-drainage',
  },
  {
    id: 'mentalHealth',
    messageId: 'LandingSpecialties.mentalHealth',
    label: 'Mental Health',
    category: 'mental-health-professional',
  },
  {
    id: 'nutritionist',
    messageId: 'LandingSpecialties.nutritionist',
    label: 'Nutritionist',
    category: 'nutritionist',
  },
  {
    id: 'chiropractor',
    messageId: 'LandingSpecialties.chiropractor',
    label: 'Chiropractor',
    category: 'chiro',
  },
  {
    id: 'pelvicFloor',
    messageId: 'LandingSpecialties.pelvicFloor',
    label: 'Pelvic Floor Therapy',
    category: 'pelvic-floor-therapist',
  },
  {
    id: 'familyNursePractitioner',
    messageId: 'LandingSpecialties.familyNursePractitioner',
    label: 'Nurse practitioner',
    category: 'family-nurse-practitioner',
  },
  {
    id: 'perinatalConsultant',
    messageId: 'LandingSpecialties.perinatalConsultant',
    label: 'Perinatal Consultant',
    category: 'perinatal-consultant',
  },
];

/**
 * Coded landing hero. Rendered by LandingPage, not by a Console section.
 */
const Hero = () => {
  const [service, setService] = useState('');
  const searchHref = service ? `/s?pub_categoryLevel1=${encodeURIComponent(service)}` : '/s';

  const onSubmit = event => {
    event.preventDefault();
    window.location.assign(searchHref);
  };

  return (
    <section className={css.root}>
      <div className={css.stage}>
        <img className={css.photo} src={heroPhoto} alt="" />
        <div className={css.scrim} aria-hidden="true" />
        <div className={css.inner}>
          <p className={css.eyebrow}>
            <FormattedMessage
              id="LandingHero.eyebrow"
              defaultMessage="Prenatal · Postpartum · Parenthood"
            />
          </p>
          <h1 className={css.title}>
            <FormattedMessage
              id="LandingHero.title"
              defaultMessage="<line>Find the postpartum</line><line>support <accent>you deserve.</accent></line>"
              values={{
                line: chunks => <span className={css.titleLine}>{chunks}</span>,
                accent: chunks => <span className={css.titleAccent}>{chunks}</span>,
              }}
            />
          </h1>
          <form className={css.search} onSubmit={onSubmit}>
            <div className={css.area}>
              <svg className={css.pin} viewBox="0 0 16 16" aria-hidden="true">
                <path
                  d="M8 1.4a4.6 4.6 0 0 0-4.6 4.6c0 3.3 4.6 8.6 4.6 8.6s4.6-5.3 4.6-8.6A4.6 4.6 0 0 0 8 1.4Zm0 6.2a1.6 1.6 0 1 1 0-3.2 1.6 1.6 0 0 1 0 3.2Z"
                  fill="currentColor"
                />
              </svg>
              <span className={css.areaText}>
                <span className={css.fieldLabel}>
                  <FormattedMessage
                    id="LandingHero.servingLabel"
                    defaultMessage="Currently serving"
                  />
                </span>
                <span className={css.place}>
                  <FormattedMessage
                    id="LandingHero.servingPlace"
                    defaultMessage="New York City area"
                  />
                </span>
              </span>
            </div>
            <a className={css.findCare} href={searchHref}>
              <FormattedMessage id="LandingHero.findCare" defaultMessage="Find Care" />
            </a>
          </form>
          <div className={css.pillScroller}>
            <ul className={css.pills}>
              <li>
                <button
                  className={css.pill}
                  type="button"
                  aria-pressed={service === ''}
                  onClick={() => setService('')}
                >
                  <FormattedMessage id="LandingHero.allServices" defaultMessage="All services" />
                </button>
              </li>
              {services.map(item => (
                <li key={item.id}>
                  <button
                    className={css.pill}
                    type="button"
                    aria-pressed={service === item.category}
                    onClick={() => setService(item.category)}
                  >
                    <FormattedMessage id={item.messageId} defaultMessage={item.label} />
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className={css.trust}>
        <Highlights />
      </div>
    </section>
  );
};

export default Hero;
